import { HistoryOutlined, MailOutlined, PrinterOutlined, StopOutlined } from '@ant-design/icons';
import { Button, Card, Col, Form, FormInstance, Modal, Row, Spin, Statistic, Typography } from 'antd';
import { CountdownProps } from 'antd/lib';
import dayjs from 'dayjs';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../assets/styles/desktop/busBooking.scss';
import ModalCancelTicket from '../../components/Modal/ModalCancelTicket';
import { Constant, DateFormat, Toast, USER_GROUP, YearFormat } from '../../config/constant';
import { convertTimeFormat } from '../../lib/utils';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { getListAgentActive } from '../../redux/slice/agents/listAgentSlice';
import { fetchAccount } from '../../redux/slice/auth/accountSlice';
import { selectAuth, setReloadDetail } from '../../redux/slice/authSlice';
import {
  cancelBooking,
  cancelBookingSelector,
  resetCancelBooking,
} from '../../redux/slice/bookings/cancelBookingSlice';
import {
  createBookingSelector,
  createBookingV2,
  filterBookingCustomer,
  getPriceBooking,
  resetBooking,
  resetListCustomers,
  resetPinCode,
  setBookingForAgentId,
} from '../../redux/slice/bookings/createBookingSlice';
import { destroyBooking } from '../../redux/slice/bookings/destroyBookingSlice';
import { getAssistBookingSelector, resetAssistBooking } from '../../redux/slice/bookings/getAssistBookingSlice';
import {
  holdingBookingSelector,
  resetDataBooking,
  resetHoldingBooking,
} from '../../redux/slice/bookings/holdingBookingSlice';
import {
  getListFilterBooking,
  getListHistoryBooking,
  listBookingSelector,
  resetDataMoveTicket,
} from '../../redux/slice/bookings/listBooking';
import { getBookingRenderV2 } from '../../redux/slice/bookings/listBookingRender';
import { resetListBookingDetail } from '../../redux/slice/bookings/listDetailTicketSlice';
import { moveTicketSelector, postUpdatePickUp, resetMoveTicket } from '../../redux/slice/bookings/moveTicketSlice';
import {
  getSendBookingMail,
  resetUpdateBooking,
  updateBookingSelector,
} from '../../redux/slice/bookings/updateBooking';
import { setToast } from '../../redux/slice/toastNotifySlice';
import ModalBooking1 from './ModalBooking1';
import ModalHistoryBooking from './ModalHistoryBooking';
import ModalPrintTicket from './tickets/ModalPrintTicket';
const ModalBooking: React.FC<any> = ({
  okText,
  cancelText,
  modalOpen,
  onCancel,
  onOk,
  listBooking,
  formSearch,
  isDetail,
  listBookingDetail,
  loading,
  targetTime,
  setTargetTicket,
  isMulti,
  isBooking,
  isListTicket,
  dataCustomerBooking,
  isDepart,
  isChangeTicket,
  setIsChangeTicket,
}) => {
  const { t } = useTranslation();
  const {
    status: statusCreateUpdate,
    price,
    loading: loadingCreate,
    errorDetail: errorCreate,
    booking_for_agent_id,
    message: messageCreate,
    pin_code,
  } = useAppSelector(createBookingSelector);
  const { status: statusHoldingUpdate, dataBooking, loading: loadingHold } = useAppSelector(holdingBookingSelector);
  const { listHistoryBooking } = useAppSelector(listBookingSelector);
  const { dataMoveTicket } = useAppSelector(moveTicketSelector);
  const {
    dataMoveTicket: dataMoveTicketDiagram,
    isMoveTicket,
    loadingListBookingDetail,
  } = useAppSelector(listBookingSelector);
  const { loadingListBooking: loadingDetailTicket } = useAppSelector((state) => state.listDetailTicket);
  const { listDataSegmentBooking, loading: loadingCheckSegment } = useAppSelector((state) => state.checkBooking);
  const [openModalNumpad, setOpenModalNumpad] = useState<boolean>(false);
  const { group, name } = useAppSelector(selectAuth);
  const { status: statusCancel } = useAppSelector(cancelBookingSelector);
  const { loadingSend } = useAppSelector(updateBookingSelector);
  const [isModalOpen, setIsModalOpen] = useState(modalOpen);
  const { Countdown } = Statistic;
  const [isOpenModalCancelTicket, setIsOpenModalCancelTicket] = useState(false);
  const [formBooking]: [FormInstance] = Form.useForm();
  const dispatch = useAppDispatch();
  const isInSurance = Form.useWatch('is_insurance', formBooking);
  const [openModalHistory, setOpenModalHistory] = useState(false);
  const [openModalPrint, setOpenModalPrint] = useState(false);
  const [countdownFinished, setCountdownFinished] = useState(false);
  const isSendMail = Form.useWatch('send', formBooking);
  const totalPrice = Form.useWatch('total_price', formBooking);
  const commissionPrice = Form.useWatch('commission_price', formBooking);
  const payment = Form.useWatch('payment_method', formBooking);
  const reasonCancel = Form.useWatch('reason_cancel', formBooking);
  const provinceId = Form.useWatch('route_id', formSearch);
  const pickUpValue = Form.useWatch('pickup_location_id', formBooking);
  const dropOffValue = Form.useWatch('drop_off_location_id', formBooking);
  const seatNumber = Form.useWatch('name_seat', formBooking);
  const searchDateBooking = dayjs(Form.useWatch('date_booking', formSearch)).format(YearFormat);
  const searchDepartTime = Form.useWatch('depart_time', formSearch);
  const isAgentId = Form.useWatch('is_agent_id', formBooking);
  const agentId = Form.useWatch('agent_id', formBooking);
  const watchSegmentId = Form.useWatch('segment_id', formBooking);
  const [listLocationDepart, setListLocationDepart] = useState<any>([]);
  const [listLocationArrive, setListLocationArrive] = useState<any>([]);
  const [segmentDepartTime, setSegmentDepartTime] = useState<string>('');
  const [segmentArriveTime, setSegmentArriveTime] = useState<string>('');
  const { listAssistBooking, segmentId, assistTransshipDepart, assistTransshipArrive } =
    useAppSelector(getAssistBookingSelector);

  useEffect(() => {
    setIsModalOpen(modalOpen);
  }, [modalOpen]);

  const modalHandleOk = () => {
    onOk();
  };

  const modalHandleCancel = () => {
    if (!isDetail && statusCreateUpdate !== Constant.DEFAULT_STATUS && dataBooking?.ticket_code) {
      dispatch(
        destroyBooking({
          ticket_code: [dataBooking?.ticket_code],
        }),
      );
    }
    dispatch(setBookingForAgentId(undefined));
    setOpenModalNumpad(false);
    formBooking.resetFields();
    onCancel();
    dispatch(resetBooking());
    dispatch(resetDataBooking());
    setCountdownFinished(false);
    dispatch(resetListCustomers());
    setSegmentDepartTime('');
    setSegmentArriveTime('');
    if (dataMoveTicketDiagram?.ticket_code || isMoveTicket) {
      dispatch(resetDataMoveTicket());
      dispatch(resetMoveTicket());
    }
  };

  const onChange: CountdownProps['onChange'] = (val) => {
    if (typeof val === 'number' && val <= 0) {
    }
  };
  const onFinishCountdown: CountdownProps['onFinish'] = () => {
    setTargetTicket(undefined);
    setCountdownFinished(true);
  };

  const scrollToErrorField = (errorFields: any) => {
    const [firstErrorField] = errorFields;
    if (firstErrorField) {
      formBooking.scrollToField(firstErrorField.name);
    }
  };
  const handleCancelTicket = () => {
    setIsOpenModalCancelTicket(false);
  };

  const onCancelSuccess = useCallback(() => {
    onCancel();
    dispatch(resetListBookingDetail());
    handleCancelTicket();
    dispatch(resetUpdateBooking());
    dispatch(resetBooking());
    dispatch(resetCancelBooking());
    setOpenModalNumpad(false);
    formBooking.resetFields();
    setSegmentDepartTime('');
    setSegmentArriveTime('');
    if (!isMulti || isDetail) {
      dispatch(
        getBookingRenderV2({
          route_id: provinceId,
          depart_date: searchDateBooking,
          depart_time: convertTimeFormat(searchDepartTime),
        }),
      );
    }
    dispatch(getListFilterBooking({ depart_date: searchDateBooking }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, formSearch, provinceId, searchDateBooking, searchDepartTime]);
  const handleOkeTicket = () => {
    if (formBooking.getFieldValue('reason_cancel')) {
      const cancelBookingData = {
        ticket_code: formBooking.getFieldValue('ticket_code'),
        seat_number: seatNumber,
        cancel_reason: formBooking.getFieldValue('reason_cancel'),
        cancel_note: formBooking.getFieldValue('reason_note'),
        is_send_mail: isSendMail?.length > 0 ? isSendMail.includes(1) : false,
        is_diagram:
          isListTicket && dataCustomerBooking ? dataCustomerBooking?.is_diagram : listBooking?.schedule?.is_diagram,
      };
      dispatch(cancelBooking(cancelBookingData));
    } else {
      dispatch(
        setToast({
          message: 'Vui lòng nhập lý do hủy',
          status: true,
          type: Toast.TYPE_ERROR,
        }),
      );
    }
  };
  const onFinish = (values: any) => {
    if (isMoveTicket && dataMoveTicket?.ticket_code) {
      if (
        ((pickUpValue && pickUpValue !== 'other') ||
          (pickUpValue === 'other' && values.pickup_extra && values.pickup_extra?.trim().length >= 3)) &&
        ((dropOffValue && dropOffValue !== 'other') ||
          (dropOffValue === 'other' && values.drop_off_extra?.trim().length >= 3))
      ) {
        const dataNewPickUp = {
          pickup_location_id: values.pickup_location_id === 'other' ? null : values.pickup_location_id,
          drop_off_location_id: values.drop_off_location_id === 'other' ? null : values.drop_off_location_id,
          pickup_extra: pickUpValue === 'other' ? values.pickup_extra : undefined,
          drop_off_extra: dropOffValue === 'other' ? values.drop_off_extra : undefined,
          old_ticket_code: dataMoveTicket?.ticket_code,
          depart_date: dayjs(listBooking?.schedule?.depart_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          schedule_id: listBooking?.schedule?.id,
          depart_time: listBooking?.schedule?.depart_time,
          seat_number: dataMoveTicket?.seat_number,
          note: listBookingDetail?.note,
        };
        dispatch(postUpdatePickUp(dataNewPickUp));
      }
    } else {
      if (listBookingDetail?.source === USER_GROUP.CARLINK) {
        formBooking.setFieldValue('payment_method', 'paid_at_company');
      }
      if (
        (listBookingDetail?.source === USER_GROUP.CARLINK ||
          (listBookingDetail?.source !== USER_GROUP.CARLINK && payment)) &&
        ((pickUpValue && pickUpValue !== 'other') ||
          (pickUpValue === 'other' && values.pickup_extra && values.pickup_extra?.trim().length >= 3)) &&
        ((dropOffValue && dropOffValue !== 'other') ||
          (dropOffValue === 'other' && values.drop_off_extra?.trim().length >= 3)) &&
        watchSegmentId
      ) {
        values.total_price = values.total_price ? Number(values.total_price.toString().replace(/,/g, '')) : undefined;
        const dataCreateBooking = {
          seat_number: isDetail ? listBookingDetail?.seat_number : dataBooking?.seat_number,
          booking_type: isMulti ? Constant.BOOKING_MULTI : Constant.BOOKING_SINGLE,
          ticket_code: isDetail ? values.ticket_code : dataBooking?.ticket_code,
          customer_name: values.customer_name,
          customer_phone: values.customer_phone,
          group_seat: isDetail && !listBookingDetail?.is_diagram ? values.group_seat : undefined,
          is_diagram:
            isListTicket && dataCustomerBooking
              ? dataCustomerBooking?.is_diagram
              : listBooking?.schedule?.is_diagram ?? listBookingDetail?.is_diagram,
          customer_email: values.customer_email,
          pickup_location_id: values.pickup_location_id === 'other' ? null : values.pickup_location_id,
          drop_off_location_id: values.drop_off_location_id === 'other' ? null : values.drop_off_location_id,
          pickup_extra: pickUpValue === 'other' ? values.pickup_extra : undefined,
          drop_off_extra: dropOffValue === 'other' ? values.drop_off_extra : undefined,
          payment_method: values.payment_method,
          is_insurance: values.is_insurance ? values.is_insurance : false,
          note: values.note,
          depart_date:
            !listBookingDetail?.schedule?.is_diagram || (dataCustomerBooking && dataCustomerBooking?.is_diagram)
              ? searchDateBooking
              : undefined,
          schedule_id:
            listBookingDetail?.schedule?.is_diagram || dataCustomerBooking?.is_diagram
              ? undefined
              : listBookingDetail?.schedule_id,
          contact_phone: values.contact_phone,
          contact_name: values.contact_name,
          contact_email: values.contact_email,
          contact_note: values.contact_note,
          booking_for_agent: values.is_agent_id ? values.is_agent_id : false,
          agent_id: isAgentId ? values.agent_id : undefined,
          price_change: pin_code ? values.total_price : undefined,
          pin_code: pin_code ? pin_code : undefined,
          segment_id: values.segment_id,
        };
        const dataBookingNoDiagram = {
          seat_number: isDetail ? listBookingDetail?.seat_number : dataBooking?.seat_number,
          booking_type: Constant.BOOKING_MULTI_CUSTOM,
          is_diagram: false,
          payment_method: values.payment_method,
          is_insurance: values.is_insurance ? values.is_insurance : false,
          note: values.note,
          depart_date:
            !listBookingDetail?.schedule?.is_diagram || (dataCustomerBooking && dataCustomerBooking?.is_diagram)
              ? searchDateBooking
              : undefined,
          schedule_id:
            listBookingDetail?.schedule?.is_diagram || dataCustomerBooking?.is_diagram
              ? undefined
              : listBookingDetail?.schedule_id,
          custom_info: [
            {
              customer_phone: values.customer_phone,
              customer_name: values.customer_name,
              customer_email: values.customer_email,
              drop_off_location_id: dropOffValue === 'other' ? null : values.drop_off_location_id,
              pickup_location_id: pickUpValue === 'other' ? null : values.pickup_location_id,
              pickup_extra: pickUpValue === 'other' ? values.pickup_extra : undefined,
              drop_off_extra: dropOffValue === 'other' ? values.drop_off_extra : undefined,
              group_seat: values.group_seat,
              ticket_code: isDetail ? values.ticket_code : dataBooking?.ticket_code,
            },
          ],
          booking_for_agent: values.is_agent_id ? values.is_agent_id : false,
          agent_id: isAgentId ? values.agent_id : undefined,
          price_change: pin_code ? values.total_price : undefined,
          pin_code: pin_code ? pin_code : undefined,
          segment_id: values.segment_id,
        };
        dispatch(setBookingForAgentId(values.agent_id));
        if (listBookingDetail?.id && !listBookingDetail?.is_diagram && isDetail) {
          dispatch(createBookingV2(dataBookingNoDiagram));
        } else {
          dispatch(createBookingV2(dataCreateBooking));
        }
      } else {
        if (!payment) {
          dispatch(
            setToast({
              message: 'Vui lòng nhập phương thức thanh toán',
              status: true,
              type: Toast.TYPE_ERROR,
            }),
          );
        }
        if (
          (values.pickup_location_id === 'other' && !values.pickup_extra?.trim()) ||
          (values.drop_off_location_id === 'other' && !values.drop_off_extra?.trim())
        ) {
          dispatch(
            setToast({
              message: 'Vui lòng nhập điểm trung chuyển khác',
              status: true,
              type: Toast.TYPE_ERROR,
            }),
          );
        }
        if (!dropOffValue || !pickUpValue) {
          dispatch(
            setToast({
              message: 'Vui lòng nhập điểm đi và điểm đến',
              status: true,
              type: Toast.TYPE_ERROR,
            }),
          );
        }
      }
    }
  };

  const cancelModalHistory = () => {
    setOpenModalHistory(false);
  };

  const cancelModalPrint = () => {
    dispatch(setReloadDetail());
    setOpenModalPrint(false);
  };
  useEffect(() => {
    if (dataBooking && !isDetail) {
      if (listBooking?.schedule?.is_diagram) {
        formBooking.setFieldsValue({
          name_seat: dataBooking?.seat_number,
          ticket_code: dataBooking?.ticket_code,
        });
      } else {
        formBooking.setFieldsValue({
          ticket_code: dataBooking?.ticket_code,
        });
      }
    }
    if (
      !isDetail &&
      !formBooking.getFieldValue('total_price') &&
      !listBookingDetail?.is_move &&
      !(listBookingDetail?.source === 'openapi' && listBookingDetail?.source === 'company')
    ) {
      formBooking.setFieldsValue({
        total_price: listBookingDetail?.price,
      });
    }
  }, [dataBooking, formBooking, isInSurance, isDetail, listBookingDetail, price, listBooking, dataCustomerBooking]);

  useEffect(() => {
    if (
      (reasonCancel === 'car_company' || reasonCancel === 'agent') &&
      isDetail &&
      commissionPrice &&
      listBookingDetail?.status !== 'reserve'
    ) {
      formBooking.setFieldValue('refund', commissionPrice);
      formBooking.setFieldValue('cancel_fee', 0);
    }
    if (
      reasonCancel === 'customer' &&
      isDetail &&
      commissionPrice &&
      listBookingDetail?.status !== 'reserve' &&
      listBookingDetail?.status !== 'paid at company'
    ) {
      formBooking.setFieldValue('refund', listBookingDetail?.refund);
      formBooking?.setFieldValue('cancel_fee', listBookingDetail?.cancel_fee);
    }
    if (isDetail && listBookingDetail?.status === 'reserve') {
      formBooking.setFieldValue('refund', listBookingDetail?.refund);
      formBooking.setFieldValue('cancel_fee', listBookingDetail?.cancel_fee);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDetail, reasonCancel, totalPrice, listBookingDetail]);

  useEffect(() => {
    if (statusHoldingUpdate === Constant.DEFAULT_STATUS) {
      dispatch(resetHoldingBooking());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusHoldingUpdate]);
  useEffect(() => {
    if (statusCreateUpdate === Constant.DEFAULT_STATUS) {
      onCancelSuccess();
      dispatch(fetchAccount());
      dispatch(resetAssistBooking());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusCreateUpdate]);

  useEffect(() => {
    if (statusCancel === Constant.DEFAULT_STATUS) {
      onCancelSuccess();
      dispatch(fetchAccount());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [statusCancel]);

  const handleOpenPrint = () => {
    dispatch(setReloadDetail());
    setOpenModalPrint(true);
  };

  useEffect(() => {
    dispatch(filterBookingCustomer({}));
  }, [dispatch]);

  useEffect(() => {
    if (
      (price || !totalPrice) &&
      listBooking?.schedule?.id &&
      !listBookingDetail?.is_move &&
      !pin_code &&
      !listBookingDetail?.price_change
    ) {
      if (!(listBookingDetail?.source === 'openapi' || listBookingDetail?.final_price)) {
        formBooking.setFieldValue('total_price', price?.total_price);
      } else {
        formBooking.setFieldValue('total_price', listBookingDetail?.final_price);
      }
    }
    if (group === USER_GROUP.AGENT) {
      if (!listBookingDetail?.agent_commission && !listBookingDetail?.is_move) {
        formBooking.setFieldValue('commission_price', price?.commission_price);
      }
    }
    if (group === USER_GROUP.CAR_COMPANY) {
      if (isAgentId && agentId && !isListTicket) {
        formBooking.setFieldValue('commission_price', price?.commission_price);
      }
    }
  }, [
    price,
    pin_code,
    formBooking,
    totalPrice,
    commissionPrice,
    group,
    listBookingDetail,
    listBooking,
    isMoveTicket,
    dataMoveTicket,
    isAgentId,
    agentId,
    isListTicket,
  ]);

  useEffect(() => {
    if (pin_code) {
      if (
        !(
          listBookingDetail?.source === 'openapi' ||
          listBookingDetail?.source === 'company' ||
          listBookingDetail?.price_change
        )
      ) {
        formBooking.setFieldValue('total_price', price?.total_price);
      } else {
        formBooking.setFieldValue('total_price', listBookingDetail?.final_price);
      }
    } else {
      if (
        !(
          listBookingDetail?.source === 'openapi' ||
          listBookingDetail?.source === 'company' ||
          listBookingDetail?.price_change
        )
      ) {
        if (price?.total_price && !listBookingDetail?.final_price) {
          formBooking.setFieldValue('total_price', price?.total_price);
        } else {
          formBooking.setFieldValue('total_price', listBookingDetail?.final_price);
        }
      } else {
        formBooking.setFieldValue('total_price', listBookingDetail?.final_price);
      }
    }
  }, [pin_code, price, listBookingDetail]);

  useEffect(() => {
    if (
      listBooking?.schedule?.id &&
      watchSegmentId &&
      (dataBooking?.seat_number || listBookingDetail?.seat_number) &&
      !(pin_code && listBookingDetail?.segment_id !== watchSegmentId)
    ) {
      dispatch(
        getPriceBooking({
          booking_type: Constant.BOOKING_SINGLE,
          schedule_id: listBooking?.schedule?.id,
          seat_number: !isDetail ? dataBooking?.seat_number : listBookingDetail?.seat_number,
          is_insurance: isInSurance ? isInSurance : false,
          pickup_location_id: pickUpValue && pickUpValue !== 'other' ? pickUpValue : null,
          drop_off_location_id: dropOffValue && dropOffValue !== 'other' ? dropOffValue : null,
          depart_date: dayjs(listBooking?.schedule?.depart_date, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          agent_id: agentId ? agentId : undefined,
          segment_id: watchSegmentId,
        }),
      );
    }
  }, [
    dispatch,
    modalOpen,
    pickUpValue,
    isInSurance,
    dropOffValue,
    dataBooking,
    listBooking,
    listBookingDetail,
    isDetail,
    isAgentId,
    agentId,
    watchSegmentId,
  ]);
  useEffect(() => {
    if (errorCreate) {
      Object.keys(errorCreate).forEach((fieldName) => {
        const errorMessage = errorCreate[fieldName][0];
        dispatch(
          setToast({
            message: errorMessage,
            status: true,
            type: Toast.TYPE_ERROR,
          }),
        );
      });
    }
  }, [errorCreate, formBooking, dispatch]);

  const handleOpenHistoryModal = () => {
    setOpenModalHistory(true);
    if (listBookingDetail?.ticket_code) {
      dispatch(
        getListHistoryBooking({
          keyword: listBookingDetail?.ticket_code,
        }),
      );
    }
  };
  useEffect(() => {
    if (countdownFinished) {
      modalHandleCancel();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countdownFinished]);

  useEffect(() => {
    if (group !== USER_GROUP.AGENT) {
      dispatch(getListAgentActive({ company_id: listBooking?.schedule?.company_info?.id }));
    }
  }, [dispatch, group]);

  useEffect(() => {
    if (messageCreate === 'Mã pin không chính xác') {
      setOpenModalNumpad(true);
      dispatch(resetPinCode());
    }
  }, [messageCreate, dispatch]);

  useEffect(() => {
    if (listBooking?.count_segment === 1 && listDataSegmentBooking?.length) {
      if (listDataSegmentBooking[0]?.segment_id) {
        formBooking.setFieldValue('segment_id', listDataSegmentBooking[0]?.segment_id);
        setListLocationDepart(
          listDataSegmentBooking[0]?.transship_depart?.length > 0 ? listDataSegmentBooking[0]?.transship_depart : [],
        );
        setListLocationArrive(
          listDataSegmentBooking[0]?.transship_arrive?.length > 0 ? listDataSegmentBooking[0]?.transship_arrive : [],
        );
        if (listLocationDepart?.length === 1) {
          formBooking.setFieldsValue({
            pickup_location_id: listLocationDepart[0]?.id,
          });
        }
        if (listLocationArrive?.length === 1) {
          formBooking.setFieldsValue({
            drop_off_location_id: listLocationArrive[0]?.id,
          });
        }
      }
    }
  }, [listBooking?.count_segment, listDataSegmentBooking, listLocationDepart, listLocationArrive]);
  useEffect(() => {
    if (listAssistBooking?.length && segmentId && modalOpen && assistTransshipDepart && assistTransshipArrive) {
      formBooking.setFieldValue('segment_id', segmentId);
      setListLocationDepart(assistTransshipDepart?.length > 0 ? assistTransshipDepart : []);
      setListLocationArrive(assistTransshipArrive?.length > 0 ? assistTransshipArrive : []);
      if (watchSegmentId) {
        dispatch(resetAssistBooking());
      }
    }
  }, [
    dispatch,
    listAssistBooking,
    formBooking,
    segmentId,
    watchSegmentId,
    modalOpen,
    assistTransshipDepart,
    assistTransshipArrive,
  ]);
  useEffect(() => {
    if (isDetail) {
      formBooking.setFieldsValue({
        segment_id: listBookingDetail?.segment_id,
        name_seat: dataMoveTicket?.seat_number
          ? dataMoveTicket?.seat_number
          : isListTicket
          ? listBookingDetail?.seat_number
          : listBooking?.schedule?.is_diagram
          ? listBookingDetail?.seat_number
          : undefined,
        ticket_code: listBookingDetail?.ticket_code,
        is_insurance: listBookingDetail?.is_insurance,
        customer_phone: !(
          listBookingDetail?.source === 'openapi' &&
          (listBookingDetail?.status === 'reserve' || listBookingDetail?.status === 'hold')
        )
          ? listBookingDetail?.customer?.phone
          : 'N/A',
        customer_name: listBookingDetail?.customer?.name,
        customer_email: !(
          listBookingDetail?.source === 'openapi' &&
          (listBookingDetail?.status === 'reserve' || listBookingDetail?.status === 'hold')
        )
          ? listBookingDetail?.customer?.email
          : 'N/A',
        pickup_location_id:
          isMoveTicket && dataMoveTicket?.ticket_code
            ? undefined
            : listBookingDetail?.pickup_extra
            ? 'other'
            : listBookingDetail?.pickup_location?.id
            ? listBookingDetail?.pickup_location?.id
            : undefined,
        drop_off_location_id:
          isMoveTicket && dataMoveTicket?.ticket_code
            ? undefined
            : listBookingDetail?.drop_off_extra
            ? 'other'
            : listBookingDetail?.drop_off_location?.id
            ? listBookingDetail?.drop_off_location?.id
            : undefined,
        total_price: listBookingDetail?.final_price,
        group_seat: !listBooking?.schedule?.is_diagram ? listBookingDetail?.group_seat : undefined,
        total_price1: listBookingDetail?.price,
        commission_price: listBookingDetail?.final_price,
        note: listBookingDetail?.note,
        payment_method: listBookingDetail?.payment_method,
        drop_off_extra: listBookingDetail?.drop_off_extra,
        pickup_extra: listBookingDetail?.pickup_extra,
        cancel_fee: listBookingDetail?.cancel_fee,
        refund: listBookingDetail?.refund,
        contact_phone: listBookingDetail?.contact?.phone,
        contact_name: listBookingDetail?.contact?.name,
        contact_email: listBookingDetail?.contact?.email,
        contact_note: listBookingDetail?.contact?.note,
        is_agent_id: listBookingDetail?.booking_for_agent ? true : false,
        agent_id: listBookingDetail?.booking_for_agent ? listBookingDetail?.booking_for_agent : '',
        final_price: listBookingDetail?.final_price,
      });
      setListLocationDepart(listBookingDetail?.transship_depart);
      setListLocationArrive(listBookingDetail?.transship_arrive);
      setSegmentDepartTime(
        `${listBookingDetail?.time?.depart_time} - ${dayjs(listBookingDetail?.time?.depart_date).format(DateFormat)}`,
      );
      setSegmentArriveTime(
        `${listBookingDetail?.time?.arrive_time} - ${dayjs(listBookingDetail?.time?.arrive_date).format(DateFormat)}`,
      );
    } else {
      formBooking.resetFields();
      if (booking_for_agent_id) {
        formBooking.setFieldsValue({ agent_id: booking_for_agent_id });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDetail, formBooking, listBookingDetail]);

  return (
    <Modal
      open={isModalOpen}
      onOk={modalHandleOk}
      onCancel={modalHandleCancel}
      cancelText={cancelText}
      okText={okText}
      centered
      footer={[]}
      width={940}
      maskClosable={false}
      className="modal-bus-booking diagram"
      confirmLoading={loading || loadingCreate || loadingSend || loadingHold || loadingCheckSegment}
    >
      <Spin spinning={isDetail ? loadingDetailTicket : false}>
        <Card className="card-modal-booking w-100">
          <Row
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              paddingBottom: 4,
              borderBottom: '1px solid #EEEEEE',
            }}
          >
            <Typography.Text className="fw-600 fs-18 ">{t('Thông tin hành khách')}</Typography.Text>
            <div style={{ marginRight: '38px' }}>
              <Row style={isDetail ? { display: 'flex', justifyContent: 'flex-end' } : {}}>
                {isDetail ? (
                  <Typography className="fs-16 fw-500 text-blue ">
                    Nguồn vé: <span className="fw-600">{listBookingDetail?.orderer?.name}</span>{' '}
                  </Typography>
                ) : (
                  <Col>
                    <Countdown
                      className="countdown-booking booking-modal"
                      title="Thời gian còn lại:"
                      value={targetTime}
                      onChange={onChange}
                      format="mm:ss"
                      onFinish={onFinishCountdown}
                    />
                  </Col>
                )}
              </Row>
              {/* <TutorialsVideo url_youtube={handleGetUrlGuide(listTutorials, 9)} /> */}
            </div>
          </Row>
          {isDetail ? (
            <Row className="w-100" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {listBookingDetail?.source !== 'openapi' && listBookingDetail?.source !== 'company' && (
                <Col className="d-flex group-btn-detail-booking">
                  <Button onClick={() => handleOpenHistoryModal()}>
                    <HistoryOutlined /> Lịch sử
                  </Button>
                  <Button onClick={() => handleOpenPrint()}>
                    <PrinterOutlined /> In vé
                  </Button>
                  <Button onClick={() => dispatch(getSendBookingMail(listBookingDetail?.id))}>
                    <MailOutlined /> Gửi SMS / Email
                  </Button>
                </Col>
              )}
            </Row>
          ) : (
            <div></div>
          )}
          <Spin spinning={loading || loadingCreate || loadingSend || loadingHold || loadingCheckSegment}>
            <Form
              layout="vertical"
              className=""
              form={formBooking}
              onFinish={onFinish}
              autoComplete="off"
              validateTrigger="onSubmit"
              labelAlign={'left'}
              labelWrap
              onFieldsChange={(allFields) => {
                scrollToErrorField(allFields.filter((field) => field.errors && field.errors.length > 0));
              }}
              initialValues={{ is_agent_id: false }}
            >
              <Row className={`time-countdown-block`}>
                <div className="d-flex justify-between w-100 mt-1"></div>
              </Row>
              <Row className="tab-booking-container mt-1">
                <Col className="w-100">
                  <ModalBooking1
                    formSearch={formSearch}
                    listBooking={listBooking}
                    isDetail={isDetail}
                    formBooking={formBooking}
                    listBookingDetail={listBookingDetail}
                    isListTicket={isListTicket}
                    dataCustomerBooking={dataCustomerBooking}
                    isBooking={isBooking}
                    isDepart={isDepart}
                    isChangeTicket={isChangeTicket}
                    setIsChangeTicket={setIsChangeTicket}
                    isMoveTicket={isMoveTicket}
                    dataMoveTicket={dataMoveTicket}
                    openModalNumpad={openModalNumpad}
                    setOpenModalNumpad={setOpenModalNumpad}
                    dataBooking={dataBooking}
                    listLocationDepart={listLocationDepart}
                    setListLocationDepart={setListLocationDepart}
                    listLocationArrive={listLocationArrive}
                    setListLocationArrive={setListLocationArrive}
                    segmentDepartTime={segmentDepartTime}
                    setSegmentDepartTime={setSegmentDepartTime}
                    segmentArriveTime={segmentArriveTime}
                    setSegmentArriveTime={setSegmentArriveTime}
                    searchDateBooking={searchDateBooking}
                  />
                </Col>
              </Row>
              <Row className="d-flex mt--8  ">
                <Col span={3} className="d-flex justify-content-start ">
                  {(listBooking?.trip?.status !== 'departed' || !isBooking) &&
                  isDetail &&
                  (listBookingDetail?.orderer?.name === name || group !== USER_GROUP.AGENT) &&
                  !(
                    listBookingDetail?.orderer?.agent?.id &&
                    !listBookingDetail?.payer?.agent?.id &&
                    group === 'agent'
                  ) &&
                  listBookingDetail?.source !== 'openapi' &&
                  !listBooking?.contract?.code ? (
                    <Button
                      key="pdf-contract"
                      type="primary"
                      className="w-128 h-btn-48 fw-600 rounded-lg"
                      htmlType="button"
                      danger
                      style={{ backgroundColor: '#D81717' }}
                      onClick={() => setIsOpenModalCancelTicket(true)}
                    >
                      <span>
                        <StopOutlined />
                        {' Hủy vé'}
                      </span>
                    </Button>
                  ) : (
                    ''
                  )}
                </Col>
                {
                  <Col span={21} className="d-flex justify-content-end gap-12">
                    <Button key="cancel" className=" w-160 h-btn-48 rounded-lg" onClick={() => modalHandleCancel()}>
                      {cancelText}
                    </Button>
                    {!listBooking?.contract?.code &&
                      listBookingDetail?.source !== 'openapi' &&
                      listBookingDetail?.source !== 'company' &&
                      ((listBooking?.trip?.status !== 'departed' && listBooking?.trip?.status === 'canceled') ||
                        !isBooking) && (
                        <Button
                          key="ok"
                          type="primary"
                          className="w-160 h-btn-48 btn-success rounded-lg"
                          style={{ marginRight: '5px' }}
                          htmlType="submit"
                          onClick={modalHandleOk}
                        >
                          {okText}
                        </Button>
                      )}
                  </Col>
                }
              </Row>
              <ModalCancelTicket
                modalOpen={isOpenModalCancelTicket}
                okText={t('Hủy vé')}
                cancelText={t('Trở lại')}
                modalTitle={t('Hủy vé')}
                onCancel={handleCancelTicket}
                onOk={handleOkeTicket}
                listBooking={listBooking}
                modalContent={t('Bạn đang thao tác hủy vé này, bạn có chắc chắn muốn hủy?')}
                isAgentId={isAgentId}
                agentId={agentId}
              />
              <ModalHistoryBooking
                modalOpen={openModalHistory}
                onOk={() => setOpenModalHistory(false)}
                onCancel={cancelModalHistory}
                historyDetail={listHistoryBooking?.length ? listHistoryBooking : []}
                listBooking={listBooking}
                isCancel={false}
                listBookingDetail={listBookingDetail}
              />
              <ModalPrintTicket
                modalOpen={openModalPrint}
                onCancel={cancelModalPrint}
                onOk={() => setOpenModalPrint(false)}
                listBooking={listBooking}
                listBookingDetail={listBookingDetail}
                dataCustomerBooking={dataCustomerBooking}
                loading={loadingListBookingDetail}
              />
            </Form>
          </Spin>
        </Card>
      </Spin>
    </Modal>
  );
};
export default ModalBooking;
